// src/createEventBus.ts
var POSTMESSAGE_TAG = "__omni_event__";
function isWireFrame(value, channel) {
  if (!value || typeof value !== "object") return false;
  const v = value;
  return v[POSTMESSAGE_TAG] === true && v.channel === channel && typeof v.event === "object";
}
function createEventBus(opts = {}) {
  const channelName = opts.channel ?? "omni-events";
  const trustedOrigins = new Set(
    [
      ...opts.trustedOrigins ?? [],
      typeof window !== "undefined" ? window.location.origin : ""
    ].filter(Boolean)
  );
  const typedHandlers = /* @__PURE__ */ new Map();
  const allHandlers = /* @__PURE__ */ new Set();
  const dispatch = (event) => {
    typedHandlers.get(event.type)?.forEach((h) => {
      try {
        h(event);
      } catch (err) {
        console.error("[omni-events] handler", event.type, err);
      }
    });
    allHandlers.forEach((h) => {
      try {
        h(event);
      } catch (err) {
        console.error("[omni-events] all handler", err);
      }
    });
  };
  let bc = null;
  if (typeof BroadcastChannel !== "undefined") {
    try {
      bc = new BroadcastChannel(channelName);
      bc.onmessage = (ev) => {
        if (!isWireFrame(ev.data, channelName)) return;
        dispatch(ev.data.event);
      };
    } catch {
      bc = null;
    }
  }
  const onWindowMessage = (ev) => {
    if (!trustedOrigins.has(ev.origin)) return;
    if (!isWireFrame(ev.data, channelName)) return;
    dispatch(ev.data.event);
  };
  if (typeof window !== "undefined") {
    window.addEventListener("message", onWindowMessage);
  }
  const publish = (event) => {
    dispatch(event);
    const frame = {
      [POSTMESSAGE_TAG]: true,
      channel: channelName,
      event
    };
    bc?.postMessage(frame);
    if (typeof window !== "undefined" && window.parent && window.parent !== window) {
      window.parent.postMessage(frame, "*");
    }
  };
  const subscribe = (type, handler) => {
    let set = typedHandlers.get(type);
    if (!set) {
      set = /* @__PURE__ */ new Set();
      typedHandlers.set(type, set);
    }
    const wrapped = handler;
    set.add(wrapped);
    return () => {
      set.delete(wrapped);
    };
  };
  const subscribeAll = (handler) => {
    allHandlers.add(handler);
    return () => {
      allHandlers.delete(handler);
    };
  };
  const close = () => {
    bc?.close();
    bc = null;
    if (typeof window !== "undefined") {
      window.removeEventListener("message", onWindowMessage);
    }
    typedHandlers.clear();
    allHandlers.clear();
  };
  return { publish, subscribe, subscribeAll, close };
}

export { createEventBus };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map